<div class="is-loading" *ngIf="isLoading">
  <div class="loading-container">
    <ion-skeleton-text class="header-item" animated></ion-skeleton-text>
    <ion-skeleton-text class="header-item" animated></ion-skeleton-text>
  </div>
  <div class="loading-container">
    <ng-container *ngFor="let quickFilter of quickFilters">
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
    </ng-container>
  </div>
</div>
<div class="filter-header" *ngIf="!isLoading">
  <div class="sub-header-section">
    <div class="date-range-section">
      <ng-container *ngIf="showQuickDateFilterOption">
        <div
          class="date-range-text"
          data-cy="usf-filtering-banner-date-range-text"
        >
          {{
            filterDateRange
              ? filterDateRange
              : ('i18n.payments.selectDateRange' | translate)
          }}
        </div>
        <ion-icon
          name="calendar-outline"
          data-cy="usf-filtering-banner-change-date-button"
          (click)="changeDateButtonClicked()"
        ></ion-icon>
      </ng-container>
    </div>
    <div class="filter-section">
      <ng-container *ngIf="showFilterModalButton">
        <ion-button
          class="usf-outline-green-button open-filters"
          data-cy="usf-filtering-banner-open-filters-button"
          [fill]="
            numberOfSelectedFilters > 0
              ? 'usf-fill-green-button'
              : 'usf-outline-green-button'
          "
          (click)="openFilterModal()"
        >
          <ion-icon slot="start" name="filter"></ion-icon>
          {{ 'i18n.common.filter' | translate }}
          <ng-container *ngIf="numberOfSelectedFilters > 0"
            >({{ numberOfSelectedFilters }})</ng-container
          >
        </ion-button>

        <span
          *ngIf="showResetFilterOption && !resetLabel"
          data-cy="usf-filtering-banner-reset-filters-button"
          (click)="resetFilters()"
          >Clear All</span
        >
        <span
          *ngIf="showResetFilterOption && resetLabel"
          data-cy="usf-filtering-banner-reset-filters-button"
          (click)="resetFilters()"
          >{{ 'i18n.common.reset' | translate }}</span
        >
      </ng-container>
    </div>
    <ng-container *ngIf="showViewTodaysOrdersButton">
      <ion-button
        class="usf-fill-green-button view-todays-orders"
        data-cy="usf-filtering-banner-view-todays-orders-button"
        (click)="getTodaysOrders()"
      >
        {{ 'i18n.importOrderPage.viewTodaysOrders' | translate }}
      </ion-button>
    </ng-container>
  </div>
  <div class="quick-filters">
    <div
      *ngFor="let quickFilter of quickFilters; let i = index"
      data-cy="usf-filtering-banner-quick-filter-button"
      (click)="toggleStatusFilter(quickFilter, i)"
      [ngClass]="quickFilter.selected ? 'selected' : ''"
    >
      <span
        class="count"
        [ngClass]="quickFilter.color ? quickFilter.color : 'red'"
        >{{ quickFilter.count }}</span
      >
      <span>{{
        (quickFilter.translationKey | translate) || quickFilter.title
      }}</span>
    </div>
  </div>
</div>
